import { SpyneTrait } from 'spyne';
import { DeckSlideView } from 'components/deck/deck-slide-view.js';

export class DeckContainerTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'deckContainer$';
    super(context, traitPrefix);
  }

  static deckContainer$OnDeckInit(e) {
    const { slides } = e.payload;
    slides.forEach((slide, slideNum) => {
      this.appendView(new DeckSlideView({ data: slide, slideNum }));
    });
  }

  // The show opens on whichever slide the reader is looking at: the one with
  // the most of itself inside the viewport when fullscreen lands.
  static deckContainer$SlideNumInViewport(props = this.props) {
    const slides = [...props.el.querySelectorAll('.deck-slide')];
    const visibleHeight = (el) => {
      const r = el.getBoundingClientRect();
      return Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    };

    return slides.reduce(
      (best, el, i) => {
        const height = visibleHeight(el);
        return height > best.height ? { height, slideNum: i } : best;
      },
      { height: -Infinity, slideNum: 0 },
    ).slideNum;
  }

  // Measure first: once data-slideshow is set the CSS hides every slide that is
  // not current, and nothing is current yet — the viewport read would be empty.
  static deckContainer$OnSlideshowActivated(e, props = this.props) {
    const slideNum = this.deckContainer$SlideNumInViewport();
    const slideCount = props.el.querySelectorAll('.deck-slide').length;

    props.el.dataset.slideshow = 'active';
    this.sendInfoToChannel(
      'CHANNEL_SLIDESHOW',
      { slideNum, maxSlideNum: Math.max(slideCount - 1, 0) },
      'CHANNEL_SLIDESHOW_VIEWPORT_REQUEST',
    );
  }

  // Back to the scrolling deck, placed (not animated) at the slide the show
  // was on. The placement waits one frame: the fullscreen layout attribute is
  // released later in this same tick, and the slide must be positioned in the
  // normal column, not the full-bleed one.
  static deckContainer$OnSlideshowDeactivated(e, props = this.props) {
    delete props.el.dataset.slideshow;

    const current = props.el.querySelector(
      `.deck-slide[data-slide-num="${e.payload?.slideNum}"]`,
    );
    requestAnimationFrame(() =>
      current?.scrollIntoView({ block: 'start', behavior: 'instant' }),
    );
  }
}
